import { render, staticRenderFns } from "./LabelCropsModal.vue?vue&type=template&id=1125618a&scoped=true"
import script from "./LabelCropsModal.vue?vue&type=script&lang=js"
export * from "./LabelCropsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125618a",
  null
  
)

export default component.exports